import type { ProjectStatus } from './projects';

export const projectStatusStyles: Record<ProjectStatus, string> = {
  'Coming Soon': 'border-transparent bg-muted text-muted-foreground',
  Voting: 'border-transparent bg-blue-500/15 text-blue-700 dark:text-blue-400',
  'Winner Selected': 'border-transparent bg-amber-500/15 text-amber-700 dark:text-amber-400',
  Production: 'border-transparent bg-emerald-500/15 text-emerald-700 dark:text-emerald-400',
  Archive: 'border-transparent bg-zinc-500/15 text-zinc-600 dark:text-zinc-400',
};

export const projectStatuses: ProjectStatus[] = [
  'Coming Soon',
  'Voting',
  'Winner Selected',
  'Production',
  'Archive',
];

export const projectFilters: Array<'All' | ProjectStatus> = ['All', ...projectStatuses];
